// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_module = require("rescript/lib/js/caml_module.js");
var MM_unification_debug = require("../mm-utils/MM_unification_debug.bs.js");

function toggleExpanded(st) {
  return {
          expanded: !st.expanded,
          expandedSrcs: st.expandedSrcs
        };
}

function expandCollapseSrc(st, srcIdx) {
  if (st.expandedSrcs.includes(srcIdx)) {
    return {
            expanded: st.expanded,
            expandedSrcs: st.expandedSrcs.filter(function (i) {
                  return i !== srcIdx;
                })
          };
  } else {
    return {
            expanded: st.expanded,
            expandedSrcs: st.expandedSrcs.concat([srcIdx])
          };
  }
}

var validProofIcon = React.createElement("span", {
      style: {
        color: "green",
        fontWeight: "bold"
      },
      title: "This is a valid proof"
    }, "\u2713");

function propsInnerAreSame(param, param$1) {
  return true;
}

var ProofNodeDtoCmp = Caml_module.init_mod([
      "MM_cmp_proof_node.res",
      64,
      4
    ], {
      TAG: /* Module */0,
      _0: [[
          /* Function */0,
          "make"
        ]]
    });

var make = React.memo((function (param) {
        var getFrmLabelBkgColor = param.getFrmLabelBkgColor;
        var frmExprToStr = param.frmExprToStr;
        var exprToReElem = param.exprToReElem;
        var exprToStr = param.exprToStr;
        var nodeIdxToLabel = param.nodeIdxToLabel;
        var isRootStmt = param.isRootStmt;
        var nodeIdx = param.nodeIdx;
        var tree = param.tree;
        var match = React.useState(function () {
              return {
                      expanded: false,
                      expandedSrcs: []
                    };
            });
        var setState = match[1];
        var state = match[0];
        var node = Caml_array.get(tree.nodes, nodeIdx);
        var getParents = function (param) {
          if (node.parents.length !== 0) {
            return node.parents;
          }
          var src = node.proof;
          if (src !== undefined) {
            return [src];
          } else {
            return [];
          }
        };
        var parents = getParents(undefined);
        var getColorForLabel = function (nodeIdx) {
          if (Curry._1(isRootStmt, nodeIdx)) {
            return "black";
          } else {
            return "lightgrey";
          }
        };
        var rndExpandCollapseIcon = function (expand) {
          var $$char = expand ? "\u229E" : "\u229F";
          return React.createElement("span", {
                      style: {
                        fontSize: "13px",
                        opacity: parents.length === 0 ? "0.0" : "1.0"
                      }
                    }, $$char);
        };
        var rndCollapsedArgs = function (args, srcIdx) {
          return React.createElement("span", {
                      style: {
                        cursor: "pointer"
                      },
                      onClick: (function (param) {
                          Curry._1(setState, (function (__x) {
                                  return expandCollapseSrc(__x, srcIdx);
                                }));
                        })
                    }, "( ", args.map(function (arg, i) {
                          return React.createElement("span", {
                                      key: String(i),
                                      style: {
                                        color: getColorForLabel(arg)
                                      }
                                    }, Curry._1(nodeIdxToLabel, arg) + " ");
                        }), " )");
        };
        var rndErr = function (err, asrtLabel) {
          return React.createElement("pre", {
                      style: {
                        color: "red",
                        margin: "0px"
                      }
                    }, MM_unification_debug.unifErrToStr(err, exprToStr, (function (__x) {
                            return Curry._2(frmExprToStr, asrtLabel, __x);
                          })));
        };
        var isAsrtWithoutHyps = function (src) {
          if (typeof src === "number") {
            return false;
          }
          switch (src.TAG | 0) {
            case /* Hypothesis */0 :
                return false;
            case /* Assertion */1 :
                return src.args.length === 0;
            case /* AssertionWithErr */2 :
                var args = src.args;
                var tmp = src.err;
                if (typeof tmp === "number") {
                  return args.length === 0;
                }
                switch (tmp.TAG | 0) {
                  case /* DisjCommonVar */0 :
                  case /* Disj */1 :
                  case /* UnprovedFloating */2 :
                      return args.length === 0;
                  default:
                    return false;
                }
            
          }
        };
        var rndExpandedArgs = function (args, srcIdx) {
          var src = Caml_array.get(parents, srcIdx);
          var tmp;
          tmp = typeof src === "number" || src.TAG !== /* AssertionWithErr */2 ? null : React.createElement("tr", undefined, React.createElement("td", undefined, rndErr(src.err, src.label)));
          return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", {
                              key: "c-args"
                            }, React.createElement("td", undefined, rndCollapsedArgs(args, srcIdx))), tmp, isAsrtWithoutHyps(src) ? React.createElement("tr", {
                                key: "-exp"
                              }, React.createElement("td", undefined, "This assertion doesn't have hypotheses.")) : args.map(function (arg, argIdx) {
                                return React.createElement("tr", {
                                            key: String(argIdx) + "-exp"
                                          }, React.createElement("td", undefined, React.createElement(ProofNodeDtoCmp.make, {
                                                    tree: tree,
                                                    nodeIdx: arg,
                                                    isRootStmt: isRootStmt,
                                                    nodeIdxToLabel: nodeIdxToLabel,
                                                    exprToStr: exprToStr,
                                                    exprToReElem: exprToReElem,
                                                    frmExprToStr: frmExprToStr,
                                                    getFrmLabelBkgColor: getFrmLabelBkgColor
                                                  })));
                              })));
        };
        var rndStatusIconForStmt = function (node) {
          return React.createElement("span", {
                      style: {
                        color: "green",
                        fontWeight: "bold",
                        visibility: Belt_Option.isSome(node.proof) ? "visible" : "hidden"
                      },
                      title: "This is proved"
                    }, "\u2713");
        };
        var rndStatusIconForSrc = function (src) {
          if (typeof src === "number") {
            return validProofIcon;
          }
          switch (src.TAG | 0) {
            case /* Hypothesis */0 :
                return validProofIcon;
            case /* Assertion */1 :
                var allArgsAreProved = src.args.every(function (arg) {
                      return Belt_Option.isSome(Caml_array.get(tree.nodes, arg).proof);
                    });
                if (allArgsAreProved) {
                  return validProofIcon;
                } else {
                  return null;
                }
            case /* AssertionWithErr */2 :
                return React.createElement("span", {
                            style: {
                              color: "red",
                              cursor: "pointer",
                              fontWeight: "bold"
                            }
                          }, "\u2717");
            
          }
        };
        var rndSrcs = function (param) {
          if (parents.length === 0) {
            return "Sources are not set.";
          } else {
            return React.createElement("table", undefined, React.createElement("tbody", undefined, parents.map(function (src, srcIdx) {
                                var key = String(srcIdx);
                                if (typeof src === "number") {
                                  return React.createElement("tr", {
                                              key: key
                                            }, React.createElement("td", {
                                                  style: {
                                                    verticalAlign: "top"
                                                  }
                                                }, rndStatusIconForSrc(src)), React.createElement("td", undefined, "VarType"), React.createElement("td", undefined, null));
                                }
                                switch (src.TAG | 0) {
                                  case /* Hypothesis */0 :
                                      return React.createElement("tr", {
                                                  key: key
                                                }, React.createElement("td", {
                                                      style: {
                                                        verticalAlign: "top"
                                                      }
                                                    }, rndStatusIconForSrc(src)), React.createElement("td", undefined, "Hyp " + src.label), React.createElement("td", undefined, null));
                                  case /* Assertion */1 :
                                  case /* AssertionWithErr */2 :
                                      break;
                                  
                                }
                                var label = src.label;
                                var args = src.args;
                                var tmp = {
                                  borderRadius: "3px"
                                };
                                var tmp$1 = Curry._1(getFrmLabelBkgColor, label);
                                if (tmp$1 !== undefined) {
                                  tmp.backgroundColor = tmp$1;
                                }
                                return React.createElement("tr", {
                                            key: key
                                          }, React.createElement("td", {
                                                style: {
                                                  verticalAlign: "top"
                                                }
                                              }, rndStatusIconForSrc(src)), React.createElement("td", {
                                                style: {
                                                  cursor: "pointer",
                                                  verticalAlign: "top"
                                                },
                                                onClick: (function (param) {
                                                    Curry._1(setState, (function (__x) {
                                                            return expandCollapseSrc(__x, srcIdx);
                                                          }));
                                                  })
                                              }, rndExpandCollapseIcon(!state.expandedSrcs.includes(srcIdx)), React.createElement("span", {
                                                    style: tmp
                                                  }, React.createElement("i", undefined, label))), React.createElement("td", undefined, state.expandedSrcs.includes(srcIdx) ? rndExpandedArgs(args, srcIdx) : rndCollapsedArgs(args, srcIdx)));
                              })));
          }
        };
        return React.createElement("table", undefined, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, rndStatusIconForStmt(node)), React.createElement("td", {
                                style: {
                                  color: getColorForLabel(nodeIdx),
                                  cursor: "pointer"
                                },
                                onClick: (function (param) {
                                    Curry._1(setState, toggleExpanded);
                                  })
                              }, rndExpandCollapseIcon(!state.expanded), Curry._1(nodeIdxToLabel, nodeIdx) + ":"), React.createElement("td", {
                                style: {
                                  cursor: "pointer"
                                },
                                onClick: (function (param) {
                                    Curry._1(setState, toggleExpanded);
                                  })
                              }, Curry._1(exprToReElem, Caml_array.get(tree.nodes, nodeIdx).expr))), state.expanded ? React.createElement("tr", undefined, React.createElement("td", undefined, null), React.createElement("td", undefined, null), React.createElement("td", undefined, rndSrcs(undefined))) : null));
      }), propsInnerAreSame);

Caml_module.update_mod({
      TAG: /* Module */0,
      _0: [[
          /* Function */0,
          "make"
        ]]
    }, ProofNodeDtoCmp, {
      make: make
    });

function MM_cmp_proof_node(props) {
  return React.createElement(ProofNodeDtoCmp.make, {
              tree: props.tree,
              nodeIdx: props.nodeIdx,
              isRootStmt: props.isRootStmt,
              nodeIdxToLabel: props.nodeIdxToLabel,
              exprToStr: props.exprToStr,
              exprToReElem: props.exprToReElem,
              frmExprToStr: props.frmExprToStr,
              getFrmLabelBkgColor: props.getFrmLabelBkgColor
            });
}

var make$1 = MM_cmp_proof_node;

exports.make = make$1;
/* validProofIcon Not a pure module */
